import overrideModalWindowTemplate from './templates/window.tpl.html';

function modalWindowDecorator($provide) {
  function modalWindowDirective($delegate) {

    const directive = $delegate[0];
    directive.template = overrideModalWindowTemplate;
    directive.templateUrl = undefined;

    const link = directive.link;

    directive.compile = () => {
      return function() {
        Reflect.apply(link, this, arguments);
      };
    };

    return $delegate;
  }
  modalWindowDirective.$inject = ['$delegate'];
  $provide.decorator('uibModalWindowDirective', modalWindowDirective);

  // ignore modal window rejections, because angular 1.6 will whine if a modal is closed
  // even if the "result" promise has a "catch" block
  // stolen from https://github.com/angular-ui/bootstrap/issues/6501#issuecomment-315074639
  $provide.decorator('$exceptionHandler', ['$delegate', function($delegate) {
    return function(exception, cause) {
      const exceptionsToIgnore = [
        'Possibly unhandled rejection: backdrop click',
        'Possibly unhandled rejection: cancel',
        'Possibly unhandled rejection: escape key press'
      ];
      if (exceptionsToIgnore.indexOf(exception) >= 0) {
        return;
      }
      $delegate(exception, cause);
    };
  }]);
}

modalWindowDecorator.$inject = ['$provide'];
export default modalWindowDecorator;
